import { Input } from '@/components/ui/Input/Input';
import { formatPastedTime, formatTimeForInput, padSecondsIfTwoParts } from '@/utils/timeInputFormat';

export interface TimeInputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'value' | 'onChange'> {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  fullWidth?: boolean;
  autoFocus?: boolean;
  /** Доп. класс на input (как у Input) */
  inputClassName?: string;
}

export function TimeInput({
  value,
  onChange,
  onPaste,
  onBlur,
  placeholder = '00:00:00',
  fullWidth,
  autoFocus,
  inputClassName,
  ...props
}: TimeInputProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(formatTimeForInput(e.target.value));
  };

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    const next = padSecondsIfTwoParts(e.target.value);
    if (next !== value) onChange(next);
    onBlur?.(e);
  };

  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault();
    onChange(formatPastedTime(e.clipboardData.getData('text')));
    onPaste?.(e);
  };

  return (
    <Input
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
      onPaste={handlePaste}
      placeholder={placeholder}
      fullWidth={fullWidth}
      autoFocus={autoFocus}
      inputClassName={inputClassName}
      {...props}
    />
  );
}
